/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["input[type=radio][_ngcontent-%COMP%]{display:none}[_nghost-%COMP%]     .sales-summary-chart svg.ngx-charts{margin-left:-35px;margin-top:35px}\n/*# sourceMappingURL=widget-sales-summary.component.css.map*/"];
export { styles as styles };
